import { Injectable } from '@angular/core';
import { RrqOptions } from '../../../../../../../../../../../common/src/options/calculations/rrq/rrq.options';
import { CalculationBaseFormFactory } from '../../../base-form/form/base-form/calculation-base-form.factory';
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class RrqFormFactory extends CalculationBaseFormFactory {

  constructor(protected readonly formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = RrqOptions;
  }
}
